import { createStore } from 'jotai';

/**
 * Store global do Jotai.
 *
 * Exportado para permitir acesso a átomos fora do contexto React
 * (ex: interceptors Axios, utilitários, testes).
 *
 * Deve ser passado para o `<Provider store={jotaiStore}>` no `JotaiProvider`.
 */
export const jotaiStore = createStore();
